import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=37af9488&scoped=true&"
import script from "./Culture.vue?vue&type=script&lang=js&"
export * from "./Culture.vue?vue&type=script&lang=js&"
import style0 from "./Culture.vue?vue&type=style&index=0&id=37af9488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af9488",
  null
  
)

export default component.exports